import styled from "styled-components";

export const StyledQuestionReadyLinks = styled.div`
  @keyframes link-item-copy-check {
    0% {
      transform: scale(0.5);
      opacity: 0;
    }
    70% {
      transform: scale(1.08);
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  width: calc(100% + 40px);
  margin-top: 20px;
  margin-inline: -20px;
  padding: 20px 25px 0;
  direction: rtl;
  background-color: #ffffff;
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  box-shadow: 0px -11px 29.9px 0px #7e8aad1a;
  box-sizing: border-box;

  .links-header {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    gap: 10px;
  }

  .links-header-divider {
    flex: 1;
    margin-inline: 10px;
    border-top: 0.5px solid var(--Color-4, #7e8aad33);
  }

  .links-title {
    margin: 0;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 10px;
    letter-spacing: -0.22px;
    color: #122243;
    text-align: right;
    vertical-align: middle;
    padding-left: 40px;
  }

  .title-icon-wrapper {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    box-shadow: 0px 2px 3.9px 0px #1222433b;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    line-height: 0;
    transition:
      transform 0.2s ease,
      box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0px 4px 8px 0px #1222433b;
    }
  }

  .title-icon {
    width: 15px;
    height: 15px;
    object-fit: contain;
    display: block;
    margin-right: 2px;
  }

  .link-item {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 0;
    padding-bottom: 16px;
  }

  .link-item-clickable {
    cursor: pointer;
  }

  .link-item-icon {
    order: 2;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(
      117.8deg,
      rgba(0, 122, 255, 0.3) 16.89%,
      rgba(0, 122, 255, 0.05) 84.91%
    );
    border: 0.5px solid #007aff;
    box-shadow: 0px 4px 10px 0px #007aff4d;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.3s ease;

    &:hover:not(.copied) {
      transform: scale(1.04);
      box-shadow: 0px 6px 14px 0px #007aff66;
    }

    &.copied {
      background: linear-gradient(
        117.8deg,
        rgba(52, 199, 89, 0.6) 16.89%,
        rgba(52, 199, 89, 0.2) 84.91%
      );
      border-color: #34c759;
      box-shadow: 0px 6px 15px 0px #34c7596d;
      transform: scale(1.05);
    }

    &.copied:hover {
      box-shadow: 0px 6px 16px 0px #34c75980;
    }

    &.copied svg {
      animation: link-item-copy-check 0.28s ease-out;
    }
  }

  .link-item-texts {
    order: 1;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .link-item-title {
    margin: 0;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 10px;
    letter-spacing: -0.22px;
    color: #122243;
    text-align: right;
    vertical-align: middle;
  }

  .link-item-subtitle {
    margin: 0;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.22px;
    color: #7e8aad;
    text-align: right;
    vertical-align: middle;
  }

  .link-divider {
    height: 1px;
    background: #e6ebf4;
    width: 100%;
    margin-bottom: 16px;
  }

  .view-responses-button {
    margin-top: 18px;
    width: 130px;
    height: 30px;
    border: none;
    border-radius: 999px;
    background: #00eab2;
    color: #122243;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.22px;
    text-align: center;
    vertical-align: middle;
    display: block;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    transition:
      transform 0.2s ease,
      box-shadow 0.2s ease,
      filter 0.2s ease;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0px 6px 14px 0px #00eab266;
      filter: brightness(0.98);
    }

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
      box-shadow: none;
    }
  }
`;
